import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Form, Card, Typography } from "antd";
import "./RegisterFirst.scss";
import InputGroup from "../../../components/InputGroup";
import MainButton from "../../../components/MainButton";
import { requireRegisterDataFirst, requireRegisterDataSecond, requireRegisterDataThird } from "../config";
import { checkMobile } from "../../../api/apiStore/Register/Register";
import register1 from "../../../assets/img/img_register_step_01_n@2x.png";
import Loading from "../../../components/Loading/Loading.jsx";

const { Title } = Typography;

export default function RegisterFirst({ sendValue }) {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [requiredEmail, setRequiredEmail] = useState(true);

  useEffect(() => {
    if(!requiredEmail) {
      form.setFields([{
        name: 'email',
        errors: []
      }]);
    }
  }, [requiredEmail])

  useEffect(() => {
    getFormInitialValue();
  }, []);

  const getFormInitialValue = () => {
    let initialValue = JSON.parse(sessionStorage.getItem("register1")) || {};
    if (typeof initialValue.birth !== "undefined") {
        initialValue.birth = moment(initialValue.birth);
    }
    return initialValue;
  };

  const getChildValue = () => {
    sessionStorage.setItem(
      "register1",
      JSON.stringify({
        ...form.getFieldsValue(),
      })
    );
  };
  const onFinish = () => {
    form
      .validateFields()
      .then(async (values) => {
        values.birth = moment(values.birth).format("YYYYMMDD");
        const { recommendCode } = JSON.parse(
          sessionStorage.getItem("register1")
        );
        sendValue({ ...values, recommendCode });
        setIsLoading(true);
        const checkMobileResp = await checkMobile({ mobile: values.mobile });
        setIsLoading(false);
        navigate("/registerSecond");
        return;
      })
      .catch((error) => {
        const { errorFields } = error;
        const filterErrorMsg = errorFields.map((item) => {
          const { errors } = item;
          item.errors = [...new Set(errors)];
          return item;
        });
      });
  };

  return (
    <div className="site-card-border-less-wrapper">
      <Loading isLoadingVisible={isLoading}></Loading>
      <Card bordered={false}>
        <img style={{ width: "100%", height: "100%" }} src={register1} />
        <Title className="register-title" level={5}>
          必填資料
        </Title>
        {/* {isErrorModalVisible ? <ErrorHandler errorList={isErrorModalVisible} /> : null} */}
        <Form form={form} initialValues={getFormInitialValue()} name="register">
          <InputGroup
            inputAry={requireRegisterDataFirst}
            className="group-wrapper-upper"
          ></InputGroup>
          <InputGroup
            inputAry={requireRegisterDataSecond}
          ></InputGroup>
          <p className="text-info">小提醒 : 生日送出後無法修改喔!</p>
          <InputGroup
          getValue={getChildValue}
          inputAry={requireRegisterDataThird}
          requiredEmail={requiredEmail}
          setRequiredEmail={setRequiredEmail}
          ></InputGroup>
          <p className="text-info">小提醒 : 若不同意電郵聯繫或無電郵者請取消勾選!</p>
          <MainButton buttonType="main" onClick={onFinish}>
            送出
          </MainButton>
        </Form>
      </Card>
    </div>
  );
}
